"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
exports.lobbySubscription = graphql_tag_1.default("subscription lobby($lobbyId: String!) {\n  lobby(lobbyId: $lobbyId) {\n    endsIn\n    startsIn\n    question {\n      title\n      options\n    }\n    users {\n      name\n      question\n      timeLeft\n      cartColor\n      costumeColor\n    }\n    resultsCalculated\n  }\n}");
